import React, { useState, useEffect } from 'react';
import './Alert.css'

const Alert = ({ 
  type = 'info', 
  message, 
  duration = 5000, 
  onClose,
  showProgress = true 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  const alertConfig = {
    success: {
      icon: '✅',
      className: 'alert-success'
    },
    error: {
      icon: '❌',
      className: 'alert-error'
    },
    warning: {
      icon: '⚠️',
      className: 'alert-warning'
    },
    info: {
      icon: 'ℹ️',
      className: 'alert-info'
    }
  };

  const currentConfig = alertConfig[type] || alertConfig.info;

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300); // Match exit animation duration
  };

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(handleClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration]);

  if (!isVisible) return null;

  return (
    <div 
      className={`alert-container ${currentConfig.className} ${isExiting ? 'alert-exit' : ''}`}
    >
      {showProgress && duration > 0 && (
        <div 
          className="alert-progress"
          style={{
            animationDuration: `${duration}ms`
          }}
        />
      )}
      
      <div className="alert-content">
        <div className="alert-icon">
          {currentConfig.icon}
        </div>
        <p className="alert-message">
          {message}
        </p>
      </div>
      
      <button 
        className="alert-close-button"
        onClick={handleClose}
        aria-label="Close alert"
      >
        ×
      </button>
    </div>
  );
};

export default Alert;

